<template>
	<div class="page-container">
		<!-- 切换按钮组 -->
		<div class="tab-buttons">
			<button class="tab-btn" :class="{ active: activeTab === 'support' }" @click="switchTab('support')">
				技术支持
			</button>
			<button class="tab-btn" :class="{ active: activeTab === 'contact' }" @click="switchTab('contact')">
				联系我们
			</button>
		</div>

		<!-- 内容卡片：宽80vw，高80vh，白色背景 -->
		<div class="content-card">
			<!-- 技术支持内容 -->
			<div class="tab-content" v-show="activeTab === 'support'">
				<h2 class="content-title">淞淞零工APP和小程序使用教程</h2>

				<div class="tutorial-content">
					<!-- 定位部分 -->
					<section class="tutorial-section">
						<h3 class="section-title">一、定位</h3>
						<p class="section-desc">
							在使用本APP时，请打开手机定位，以便手机自动定位您的位置，并为您搜索就近的相关工种工作人员或把您推送给用工方。
						</p>
					</section>

					<!-- 找人干活部分 -->
					<section class="tutorial-section">
						<h3 class="section-title">二、找人干活</h3>
						<p class="section-desc">
							打开APP后，即为“找人干活”页面。使用“找人干活“功能不需要注册。
						</p>
						<p class="section-desc">
							“找人干活”功能分为“地图模式”、“列表模式”和“自行发布”三种模式。
						</p>

						<div class="sub-section">
							<h4 class="sub-section-title">1. 地图模式：</h4>
							<p class="sub-section-desc">
								用户根据需要，自行设置“找人干活”的工种和干活位置，地图即以干活位置为中心，以红色定位符方式显示周边可接单的工作人员。点击红色定位符，即可查看工作人员信息和拨打电话。同时地图可以通过左下角两个图标按钮进行缩放，也可以手动进行缩放。
							</p>
						</div>

						<div class="sub-section">
							<h4 class="sub-section-title">2. 列表模式：</h4>
							<p class="sub-section-desc">
								用户根据需要，自行设置“找人干活”的工种和干活位置，列表即以距离干活位置的远近，以列表的方式显示可接单的工作人员。用户也可以根据工作人员的评分高低选择干活人员。
							</p>
						</div>

						<div class="sub-section">
							<h4 class="sub-section-title">3. 自行发布：</h4>
							<p class="sub-section-desc">
								用户可以通过发布干活信息的方式，将干活信息通过平台向周边可接单工作人员发布，由工作人员接单。
							</p>
						</div>
					</section>

					<!-- 我要干活部分 -->
					<section class="tutorial-section">
						<h3 class="section-title">三、我要干活</h3>
						<p class="section-desc">
							点击“我要干活”选项卡，即进入“我要干活”模块。
						</p>
						<p class="section-desc">
							要使用“我要干活”功能，需在“个人中心”进行会员注册。
						</p>
						<p class="section-desc">
							“我要干活”功能分为“地图模式”和“列表模式”。
						</p>

						<div class="sub-section">
							<h4 class="sub-section-title">1. 地图模式：</h4>
							<p class="sub-section-desc">
								打开地图模式，APP即可根据您现在的位置定位和工种，将您附近由“找人干活”中“自行发布”推送的用工需求用红色定位符显示，用户可通过点击红色定位符查看用工需求和拨打电话联系。
							</p>
						</div>

						<div class="sub-section">
							<h4 class="sub-section-title">2. 列表模式：</h4>
							<p class="sub-section-desc">
								打开列表模式，APP即可根据您现在的位置定位和工种，将您附近由“找人干活”中“自行发布”推送的用工需求用列表方式显示，用户可通过点击列表内容查看用工需求和拨打电话联系。
							</p>
						</div>
					</section>

					<!-- 注册续费部分 -->
					<section class="tutorial-section">
						<h3 class="section-title">四、注册与续费</h3>

						<div class="sub-section">
							<p class="sub-section-desc">
								1.需要进行零工或兼职工作的人员，使用此功能，只有注册后，才可以使用“我要干活”功能。
							</p>
						</div>

						<div class="sub-section">
							<p class="sub-section-desc">
								2.本APP暂不收取任何注册费用。
							</p>
						</div>

						<div class="sub-section">
							<p class="sub-section-desc">
								3.点击“个人中心”选项卡，进入“淞淞会员”功能页面，即可进行注册或续费。
							</p>
						</div>

						<div class="sub-section">
							<p class="sub-section-desc">
								4.如果您的会员将到期，APP会在“个人中心”的“通知消息”页面对您进行告知。
							</p>
						</div>
					</section>

					<!-- 接单状态部分 -->
					<section class="tutorial-section">
						<h3 class="section-title">五、接单状态</h3>
						<p class="section-desc">
							进行零工或兼职工作的人员注册后，在会员期内，APP右上方会显示“接单状态”按钮，零工或兼职工作的人员可根据个人意愿或状态，确定当前是否可以接单。
						</p>
						<p class="section-desc">
							打开"接单状态”后，“找人干活”就可以在地图或列表中找到您，并可以与您联系。
						</p>
						<p class="section-desc">
							关闭“接单状态”后，“找人干活”就不能在地图或列表中找到您。
						</p>
					</section>

					<!-- 工作费用部分 -->
					<section class="tutorial-section">
						<h3 class="section-title">六、工作费用</h3>
						<p class="section-desc">
							本APP不参与工作费用结算，工作费用由用工和工作双方协定价格后自行结算。本APP也不在工作费用中抽取任何费用。
						</p>
					</section>
				</div>
			</div>

			<!-- 联系我们内容 -->
			<div class="tab-content" v-show="activeTab === 'contact'">
				<h2 class="content-title">联系我们</h2>

				<div class="contact-content">
					<div class="contact-card">
						<div class="contact-item">
							<span class="contact-label">公司：</span>
							<span class="contact-value">通辽市易淞网络信息有限公司</span>
						</div>

						<div class="contact-item">
							<span class="contact-label">地址：</span>
							<span class="contact-value">内蒙古通辽市经济技术开发区旭园9#楼4层</span>
						</div>

						<div class="contact-item">
							<span class="contact-label">电话：</span>
							<a href="tel:18847552036" class="contact-value">18847552036</a>
						</div>

						<div class="contact-item">
							<span class="contact-label">邮箱：</span>
							<a href="mailto:1046032005@qq.com" class="contact-value">1046032005@qq.com</a>
						</div>
					</div>

					<div class="contact-note">
						<p>如果您在使用过程中遇到任何问题，欢迎通过以上方式联系我们，我们将尽快为您提供帮助。</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		ref
	} from 'vue';

	export default {
		name: 'HelpCenter',
		setup() {
			const activeTab = ref('support');

			const switchTab = (tab) => {
				activeTab.value = tab;
				// 切换后滚动到顶部
				document.querySelector('.content-card').scrollTop = 0;
			};

			return {
				activeTab,
				switchTab
			};
		}
	};
</script>

<style scoped>
	.page-container {
		height: 90vh;
		background-color: #f0f5ff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		padding: 20px 0;
		box-sizing: border-box;
		font-family: 'Microsoft YaHei', sans-serif;
		z-index: 100;
	}

	/* 切换按钮组 */
	.tab-buttons {
		display: flex;
		gap: 15px;
		margin-bottom: 20px;
		z-index: 10;
	}

	.tab-btn {
		padding: 10px 25px;
		font-size: 16px;
		font-weight: 600;
		border: 2px solid #165dff;
		border-radius: 30px;
		background-color: #ffffff;
		color: #165dff;
		cursor: pointer;
		transition: all 0.3s ease;
		outline: none;
	}

	.tab-btn:hover {
		background-color: #f0f5ff;
	}

	.tab-btn.active {
		background-color: #165dff;
		color: #ffffff;
		box-shadow: 0 4px 10px rgba(22, 93, 255, 0.2);
	}

	/* 内容卡片 */
	.content-card {
		width: 50vw;
		height: 80vh;
		background-color: #ffffff;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
		padding: 30px;
		box-sizing: border-box;
		overflow-y: auto;
		scroll-behavior: smooth;
	}

	/* 修复错误的注释 */
	.content-card::-webkit-scrollbar {
		width: 6px;
	}

	.content-card::-webkit-scrollbar-track {
		background: #f5f5f5;
		border-radius: 3px;
	}

	.content-card::-webkit-scrollbar-thumb {
		background: #ccc;
		border-radius: 3px;
	}

	.content-card::-webkit-scrollbar-thumb:hover {
		background: #999;
	}

	/* 内容标题 */
	.content-title {
		font-size: 22px;
		font-weight: 600;
		color: #333;
		margin: 0 0 25px 0;
		padding-left: 15px;
		border-left: 4px solid #165dff;
	}

	/* 教程内容样式 */
	.tutorial-content {
		color: #666;
		line-height: 1.8;
		font-size: 14px;
	}

	.tutorial-section {
		margin-bottom: 10px;
		padding-bottom: 20px;
		border-bottom: 1px solid #eee;
	}

	.tutorial-section:last-child {
		border-bottom: none;
		margin-bottom: 10px;
		padding-bottom: 0;
	}

	.section-title {
		font-size: 18px;
		color: #333;
		margin: 0 0 15px 0;
	}

	.section-desc {
		margin: 0 0 15px 0;
		text-align: left;
		padding-left: 30px;
	}

	.sub-section {
		margin: 0 0 15px 25px;
	}

	.sub-section-title {
		font-size: 16px;
		color: #333;
		margin: 0 0 8px 0;
		display: flex;
		align-items: center;
	}

	.sub-section-title::before {
		content: '';
		display: inline-block;
		width: 8px;
		height: 8px;
		background-color: #165dff;
		border-radius: 50%;
		margin-right: 10px;
	}

	.sub-section-desc {
		margin: 0 0 10px 18px;
		text-align: left;
	}

	/* 联系我们内容样式 */
	.contact-content {
		color: #666;
		line-height: 2;
		font-size: 14px;
		/* width: 70%; */
		/* margin: 0 auto; */
	}

	.contact-card {
		margin-bottom: 30px;
		width: 30vw;
		margin: 0 auto;
	}

	.contact-item {
		margin-bottom: 15px;
		/* padding: 0 100px; */
		text-align: left;
	}

	.contact-label {
		font-weight: 600;
		color: #333;
		margin-right: 10px;
		display: inline-block;
		min-width: 60px;
	}

	.contact-value {
		color: #666;
		text-decoration: none;
	}

	.contact-value:hover {
		color: #165dff;
		text-decoration: underline;
	}

	.contact-note {
		padding: 15px;
		background-color: #f8f9fa;
		border-radius: 8px;
		border-left: 4px solid #165dff;
	}

	.contact-note p {
		margin: 0;
	}

	/* 切换动画 */
	.tab-content {
		animation: fadeIn 0.3s ease-in-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	/* 响应式适配 */
	@media (max-width: 768px) {
		.page-container {
			padding: 15px 0;
		}

		.tab-buttons {
			flex-direction: column;
			gap: 10px;
			width: 80vw;
		}

		.tab-btn {
			width: 100%;
			padding: 12px;
		}

		.content-card {
			padding: 20px 15px;
		}

		.content-title {
			font-size: 20px;
			margin-bottom: 20px;
		}

		.section-title {
			font-size: 16px;
		}

		.sub-section {
			margin-left: 15px;
		}
	}
</style>